import React, { useState, useEffect } from 'react';
import {
  PlusOutlined,
  DeleteOutlined,
  SaveOutlined,
  RollbackOutlined,
  ClearOutlined,
} from '@ant-design/icons';
import {
  Form,
  Input,
  Button,
  Select,
  DatePicker,
  Card,
  Typography,
  message,
  Row,
  Col,
  Table,
  InputNumber,
  Spin,
  Grid,
} from 'antd';
import dayjs from 'dayjs';
import { getParties, getVehicleInsurancesByParty, createBill, getBillById, updateBill, getBills } from '../Services/Services';

const { Text } = Typography;
const { Option } = Select;
const { useBreakpoint } = Grid;

const BillForm = ({ onBack, editMode, paymentId }) => {
  const [loading, setLoading] = useState(false);
  const [fetchingData, setFetchingData] = useState(false);
  const [partyList, setPartyList] = useState([]);
  const [filteredVehicles, setFilteredVehicles] = useState([]);
  const [form] = Form.useForm();
  console.log(paymentId, 'paymentId')
  const screens = useBreakpoint();
  const isMobile = !screens.md; // true for screens < 768px

  const [billHeader, setBillHeader] = useState({
    party_id: '',
    party_name: '',
    mobile: '',
    address: '',

    bill_date: dayjs()
  });

  const [rows, setRows] = useState([
    { id: Date.now(), vehicle_id: '', vehicle_no: '', chassis_number: '', amount: '', date: dayjs(), description: '' }
  ]);

  useEffect(() => {
    fetchParties();
    fetchNextBillNo();
  }, []);
  const fetchNextBillNo = async () => {
    try {
      const data = await getBills();

      form.setFieldsValue({
        bill_id: data.next_bill_no
      });

    } catch (error) {
      console.log(error);
    }
  };


  useEffect(() => {
    if (editMode && paymentId) {
      fetchBillData();
    }
  }, [editMode, paymentId]);

  useEffect(() => {
    if (billHeader.party_id && partyList.length > 0 && !billHeader.mobile) {
      const partyDetails = partyList.find(p => p.id === billHeader.party_id);
      if (partyDetails) {
        setBillHeader(prev => ({
          ...prev,
          mobile: partyDetails.mobileNumber || '',
          address: partyDetails.address || ''
        }));
      }
    }
  }, [partyList, billHeader.party_id]);

  const fetchParties = async () => {
    try {
      const data = await getParties();
      if (data) setPartyList(data.results || data || []);
    } catch (error) {
      message.error("Failed to fetch parties");
    }
  };

  const fetchBillData = async () => {
    setFetchingData(true);
    try {
      const response = await getBillById(paymentId);
      console.log(response);
      const data = response.results[0];
      if (data) {
        setBillHeader({
          party_id: data.party_id,
          party_name: data.party_name || '',
          mobile: data.mobile || '',
          address: data.address || '',
          bill_id: data.bill_id || '',
          bill_date: data.bill_date ? dayjs(data.bill_date) : dayjs()
        });
        const itemsList = data.items || [];
        if (itemsList.length > 0) {
          const formattedRows = itemsList.map((item, index) => ({
            id: item.id || Date.now() + index,
            vehicle_id: item.vehicle_id,
            vehicle_no: item.vehicle_no || '',
            chassis_number: item.chassis_number || '',
            amount: item.amount,
            date: item.service_date ? dayjs(item.service_date) : dayjs(),
            description: item.description || ''
          }));
          setRows(formattedRows);
        }
        await fetchVehiclesByParty(data.party_id);
        form.setFieldsValue({
          party_id: data.party_id,
          bill_id: data.bill_id,
          bill_date: data.bill_date ? dayjs(data.bill_date) : dayjs()
        });
        const vehicles = await getVehicleInsurancesByParty(data.party_id);

        const vehicleList = vehicles.results || vehicles || [];

        const formattedRows = itemsList.map((item, index) => {
          const vehicle = vehicleList.find(
            v => Number(v.id) === Number(item.vehicle_id)
          );

          return {
            id: item.id || Date.now() + index,
            vehicle_id: item.vehicle_id,
            vehicle_no: item.vehicle_no || vehicle?.vehicleNo || '',
            chassis_number:
              vehicle?.chassisNumber ||
              item.chassis_number ||
              '',
            amount: item.amount,
            date: item.service_date ? dayjs(item.service_date) : dayjs(),
            description: item.description || ''
          };
        });

        setRows(formattedRows);

      }
    } catch (error) {
      console.log(error);
      message.error("Failed to load bill data");
    } finally {
      setFetchingData(false);
    }
  };

  const fetchVehiclesByParty = async (partyId) => {
    try {
      const data = await getVehicleInsurancesByParty(partyId);
      if (data && data.results) {
        setFilteredVehicles(data.results);
      } else if (data && Array.isArray(data)) {
        setFilteredVehicles(data);
      } else {
        setFilteredVehicles([]);
      }
    } catch (error) {
      console.error("Error fetching vehicles:", error);
      setFilteredVehicles([]);
    }
  };

  const handlePartyChange = async (selectedId) => {
    const partyDetails = partyList.find(p => p.id === parseInt(selectedId));
    if (partyDetails) {
      setBillHeader({
        ...billHeader,
        party_id: partyDetails.id,
        party_name: partyDetails.partyName,
        mobile: partyDetails.mobileNumber || '',
        address: partyDetails.address || ''
      });
      setRows([{ id: Date.now(), vehicle_id: '', vehicle_no: '', amount: '', date: dayjs(), description: '' }]);
      await fetchVehiclesByParty(partyDetails.id);
    } else {
      setBillHeader({ ...billHeader, party_id: '', party_name: '', mobile: '', address: '' });
      setFilteredVehicles([]);
      setRows([{ id: Date.now(), vehicle_id: '', vehicle_no: '', amount: '', date: dayjs(), description: '' }]);
    }
  };

  const handleVehicleChange = (rowId, vehicleId) => {
    const vehicleDetails = filteredVehicles.find(v => v.id === parseInt(vehicleId));
    const updatedRows = rows.map(row =>
      row.id === rowId ? {
        ...row,
        vehicle_id: vehicleId,
        vehicle_no: vehicleDetails ? vehicleDetails.vehicleNo : '',
        chassis_number: vehicleDetails ? vehicleDetails.chassisNumber : ''
      } : row
    );
    setRows(updatedRows);
  };

  const totalAmount = rows.reduce((sum, row) => sum + (Number(row.amount) || 0), 0);

  const addRow = () => {
    setRows([...rows, { id: Date.now(), vehicle_id: '', vehicle_no: '', chassis_number: '', amount: '', date: dayjs(), description: '' }]);
  };

  const removeRow = (id) => {
    if (rows.length > 1) {
      setRows(rows.filter(row => row.id !== id));
    } else {
      message.error("At least one row is required!");
    }
  };

  const handleRowChange = (id, field, value) => {
    const updatedRows = rows.map(row =>
      row.id === id ? { ...row, [field]: value } : row
    );
    setRows(updatedRows);
  };

  const clearForm = () => {

    setBillHeader({
      party_id: '',
      party_name: '',
      mobile: '',
      address: '',

      bill_date: dayjs()
    });
    setRows([{ id: Date.now(), vehicle_id: '', vehicle_no: '', amount: '', date: dayjs(), description: '' }]);
    setFilteredVehicles([]);
    form.resetFields();
    message.info("Form cleared");
  };

  const handleSaveForm = async () => {
    if (!billHeader.party_id) {
      message.error("Please select a Party");
      return;
    }
    if (rows.some(r => !r.vehicle_id || !r.amount)) {
      message.error("Please fill vehicle and amount in all rows");
      return;
    }

    setLoading(true);
    const billId = form.getFieldValue('bill_id')
    const payload = {
      header: {
        party_id: parseInt(billHeader.party_id),
        bill_date: billHeader.bill_date ? billHeader.bill_date.format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD'),
        total_amount: totalAmount,
        bill_id: billId 
      },
      entries: rows.map(row => ({
        vehicle_id: parseInt(row.vehicle_id),
        chassis_number: row.chassis_number,
        amount: parseFloat(row.amount),
        service_date: row.date ? row.date.format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD'),
        description: row.description || ""
      }))
    };

    try {
      let response;
      if (editMode) {
        console.log(paymentId, 'paymentId');
        response = await updateBill(paymentId, payload);
      } else {
        response = await createBill(payload);
      }

      if (response) {
        message.success(editMode ? "Bill Updated Successfully!" : "Bill Saved Successfully!", 2);
        fetchNextBillNo();

        if (!editMode) {

          setBillHeader({
            party_id: '',
            party_name: '',
            mobile: '',
            address: '',

            bill_date: dayjs()
          });
          setRows([{ id: Date.now(), vehicle_id: '', vehicle_no: '', amount: '', date: dayjs(), description: '' }]);
          setFilteredVehicles([]);
          form.resetFields();
        } else {
          setTimeout(() => {
            if (onBack) onBack();
          }, 1500);
        }
      }
    } catch (error) {
      message.error(error.message || (editMode ? "Update failed!" : "Server error while saving form."));
      console.log("STATUS", error.response?.status);
      console.log("DATA", error.response?.data);
      console.log("URL", error.config?.url);
    } finally {
      setLoading(false);
    }
  };

  if (fetchingData) {
    return (
      <div style={{ minHeight: '100vh' }}>
        <Card style={{ textAlign: 'center', padding: 40 }}>
          <Spin size="large" />
          <div style={{ marginTop: 16 }}>Loading Bill Data...</div>
        </Card>
      </div>
    );
  }

  // ------------- RENDER: DESKTOP TABLE or MOBILE STACKED CARDS -------------
  const renderServiceItems = () => {
    if (!isMobile) {
      // DESKTOP: original table (no horizontal scroll on desktop anyway)
      return (
        <Table
          columns={[
            {
              title: 'Vehicle No.',
              key: 'vehicle',
              width: '22%',
              render: (_, record) => (
                <Select
                  style={{ width: '100%' }}
                  placeholder="Select Vehicle"
                  value={record.vehicle_id || undefined}
                  onChange={(value) => handleVehicleChange(record.id, value)}
                  disabled={!billHeader.party_id}
                  size="small"
                  showSearch
                  optionFilterProp="children"
                >
                  <Option value="">-- Select --</Option>
                  {filteredVehicles.map((vehicle) => (
                    <Option key={vehicle.id} value={vehicle.id}>
                      {vehicle.vehicleNo}
                    </Option>
                  ))}

                </Select>
              )
            },
            {
              title: 'Chassis No.',
              key: 'chassis',
              width: '20%',
              render: (_, record) => (
                <Input
                  value={record.chassis_number || ''}
                  disabled
                  size="small"
                />
              )
            },

            {
              title: 'Amount (₹)',
              key: 'amount',
              width: '15%',
              render: (_, record) => (
                <InputNumber
                  style={{ width: '100%' }}
                  placeholder="0"
                  value={record.amount}
                  onChange={(value) => handleRowChange(record.id, 'amount', value)}
                  min={0}
                  precision={2}
                  size="small"
                />
              )
            },
            {
              title: 'Service Date',
              key: 'date',
              width: '15%',
              render: (_, record) => (
                <DatePicker
                  style={{ width: '100%' }}
                  value={record.date}
                  onChange={(date) => handleRowChange(record.id, 'date', date)}
                  format="DD/MM/YYYY"
                  size="small"
                  placeholder="Date"
                />
              )
            },
            {
              title: 'Description',
              key: 'description',
              render: (_, record) => (
                <Input
                  placeholder="Remarks"
                  value={record.description}
                  onChange={(e) => handleRowChange(record.id, 'description', e.target.value)}
                  size="small"
                />
              )
            },
            {
              title: '',
              key: 'action',
              width: '8%',
              align: 'center',
              render: (_, record) => (
                <Button
                  type="text"
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() => removeRow(record.id)}
                  size="small"
                  disabled={rows.length === 1}
                />
              )
            }
          ]}
          dataSource={rows}
          rowKey="id"
          pagination={false}
          size="small"
          footer={() => (
            <div style={{ textAlign: 'right', padding: '8px 12px' }}>
              <Text strong>Total: ₹{totalAmount.toLocaleString('en-IN')}</Text>
            </div>
          )}
        />
      );
    } else {
      // MOBILE: stacked cards - no horizontal scroll, ek ke neeche ek
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {rows.map((record) => (
            <Card
              key={record.id}
              size="small"
              style={{ borderRadius: 8, backgroundColor: '#fafafa' }}
              bodyStyle={{ padding: '12px' }}
              extra={
                <Button
                  type="text"
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() => removeRow(record.id)}
                  size="small"
                  disabled={rows.length === 1}
                />
              }
            >
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div>
                  <Text type="secondary" style={{ fontSize: 12 }}>Vehicle No.</Text>
                  <Select
                    style={{ width: '100%', marginTop: 4 }}
                    placeholder="Select Vehicle"
                    value={record.vehicle_id || undefined}
                    onChange={(value) => handleVehicleChange(record.id, value)}
                    disabled={!billHeader.party_id}
                    size="middle"
                    showSearch
                    optionFilterProp="children"
                  >
                    <Option value="">-- Select --</Option>
                    {filteredVehicles.map((vehicle) => (
                      <Option key={vehicle.id} value={vehicle.id}>
                        {vehicle.vehicleNo}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div>
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    Chassis No.
                  </Text>

                  <Input
                    value={record.chassis_number || ''}
                    disabled
                    style={{ marginTop: 4 }}
                  />
                </div>
                <div>
                  <Text type="secondary" style={{ fontSize: 12 }}>Amount (₹)</Text>
                  <InputNumber
                    style={{ width: '100%', marginTop: 4 }}
                    placeholder="0"
                    value={record.amount}
                    onChange={(value) => handleRowChange(record.id, 'amount', value)}
                    min={0}
                    precision={2}
                    size="middle"
                  />
                </div>
                <div>
                  <Text type="secondary" style={{ fontSize: 12 }}>Service Date</Text>
                  <DatePicker
                    style={{ width: '100%', marginTop: 4 }}
                    value={record.date}
                    onChange={(date) => handleRowChange(record.id, 'date', date)}
                    format="DD/MM/YYYY"
                    size="middle"
                    placeholder="Select date"
                  />
                </div>
                <div>
                  <Text type="secondary" style={{ fontSize: 12 }}>Description</Text>
                  <Input
                    style={{ marginTop: 4 }}
                    placeholder="Remarks"
                    value={record.description}
                    onChange={(e) => handleRowChange(record.id, 'description', e.target.value)}
                    size="middle"
                  />
                </div>
              </div>
            </Card>
          ))}
          <div style={{ textAlign: 'right', padding: '8px 0' }}>
            <Text strong>Total: ₹{totalAmount.toLocaleString('en-IN')}</Text>
          </div>
        </div>
      );
    }
  };

  return (
    <div style={{ width: '100%', padding: '0 8px', boxSizing: 'border-box' }}>
      <Form form={form} layout="vertical">
        {/* Header Card */}
        <Card size="small" style={{ marginBottom: 16, borderRadius: 8 }}>
          <Row gutter={[12, 8]}>
            <Col xs={24} sm={12} md={6}>
              <Form.Item name="party_id" label="Party" required style={{ marginBottom: 4 }}
                rules={[{ required: true, message: 'Please select a party' }]}>
                <Select
                  placeholder="Select Party"
                  value={billHeader.party_id || undefined}
                  onChange={handlePartyChange}
                  showSearch
                  size="middle"
                  optionFilterProp="children"
                  disabled={editMode}
                >
                  {partyList.map((party) => (
                    <Option key={party.id} value={party.id}>
                      {party.partyName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <Form.Item name="bill_id" label="Bill No" style={{ marginBottom: 4 }}>
                <Input
                  placeholder="Auto Generated"
                  disabled
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <Form.Item name="bill_date" label="Bill Date" initialValue={dayjs()} style={{ marginBottom: 4 }}>
                <DatePicker
                  style={{ width: '100%' }}
                  value={billHeader.bill_date}
                  onChange={(date) => setBillHeader({ ...billHeader, bill_date: date })}
                  format="DD/MM/YYYY"
                  size="middle"
                />
              </Form.Item>
            </Col>
            {billHeader.mobile && (
              <Col xs={24} sm={12} md={6}>
                <Form.Item label="Mobile" style={{ marginBottom: 4 }}>
                  <Input value={billHeader.mobile} disabled size="middle" />
                </Form.Item>
              </Col>
            )}
          </Row>
          {billHeader.address && (
            <Row>
              <Col span={24}>
                <Form.Item label="Address" style={{ marginBottom: 0 }}>
                  <Input value={billHeader.address} disabled size="middle" />
                </Form.Item>
              </Col>
            </Row>
          )}
        </Card>

        {/* Service Items Section */}
        <Card
          size="small"
          style={{ marginBottom: 16, borderRadius: 8 }}
          title={editMode ? "Edit Service Items" : "Service Items"}
          extra={
            <Button
              type="dashed"
              icon={<PlusOutlined />}
              onClick={addRow}
              disabled={!billHeader.party_id}
              size="small"
            >
              Add
            </Button>
          }
        >
          {renderServiceItems()}
        </Card>

        {/* Action Buttons */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, flexWrap: 'wrap', marginBottom: 24 }}>
          {onBack && (
            <Button icon={<RollbackOutlined />} onClick={onBack} size="middle">
              {editMode ? 'Cancel' : 'Back'}
            </Button>
          )}
          {!editMode && (
            <Button icon={<ClearOutlined />} onClick={clearForm} danger size="middle">
              Clear
            </Button>
          )}
          <Button type="primary" icon={<SaveOutlined />} onClick={handleSaveForm} loading={loading} size="middle">
            {loading ? (editMode ? 'Updating...' : 'Saving...') : (editMode ? 'Update Bill' : 'Save Bill')}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default BillForm;